import React, { Fragment, useState, useEffect } from "react";
import { ArrowRightCircle } from 'react-feather';
import useResize from "~/hooks/useResize";

import OverlayModal from "~/components/overlayModal";
import List from "./List";

import User from "~/services/user";


const GettingStarted = ({setExpandedHeader, breakpoint})=> {

  const [reload      , setReload]      = useState(false);
  const [loading     , setLoading]     = useState(true);
  const [overlayOpen , setOverlayOpen] = useState(false);
  const [checklist   , setChecklist]   = useState({
    alreadyClaimed: true,
    checks: {}
  });

  const [ width ] = useResize();

  useEffect(()=> {
    (async ()=> {
      setChecklist(await User.checklist());
      setLoading(false);
    })();
  }, [reload]);

  if (checklist.alreadyClaimed || loading) return  null;

  return (
    <Fragment>
      <div className='activity-card'>
        <p className="title"> Start earning in 9 simple steps and get an extra bonus of 2.000 points</p>
        <span> Tasks Done: </span> <p className="badge"> { Object.values(checklist.checks).filter(item=>item).length }/{ Object.keys(checklist.checks).length } </p>
        <div>
          <button className="go-to" onClick={()=> { setExpandedHeader(false); setOverlayOpen(true) } }> See all tasks <ArrowRightCircle style={{verticalAlign: 'top'}} /> </button>
        </div>
      </div>

      <OverlayModal opened={overlayOpen} bg="#eef2f6" title="Complete the tasks and get the bonus" onClose={()=>{ setExpandedHeader(width < breakpoint); setOverlayOpen(false); }}>
        <div className="m-t-20">
          <List checklist={checklist.checks} setReload={setReload} />
        </div>
      </OverlayModal>
    </Fragment>
  );
}

export default GettingStarted;
